var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relationItem" },
    [
      this.$root.isIngredients ? _c("backToIngredients") : _vm._e(),
      !this.$root.isIngredients
        ? _c("div", [
            (!_vm.needSetup && _vm.show) || _vm.admin
              ? _c(
                  "p",
                  { staticClass: "heading" },
                  [
                    _vm._v(_vm._s(_vm.heading) + " "),
                    _vm.admin
                      ? _c("font-awesome-icon", {
                          class: ["settings", _vm.settingsMode ? "active" : ""],
                          attrs: { icon: ["fas", "cog"] },
                          on: {
                            click: function ($event) {
                              _vm.settingsMode = !_vm.settingsMode
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      this.$root.isIngredients &&
      (_vm.items.length > 1 || _vm.items != undefined)
        ? _c("div", [
            _c(
              "p",
              { staticClass: "heading" },
              [
                _c("webmessage", {
                  attrs: {
                    searchKey: "wsm_productsThatContainIngredient",
                    text: _vm.$root.language.wsm_productsThatContainIngredient,
                  },
                }),
                _vm._v(_vm._s(_vm.ingredientName)),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.settingsMode && _vm.admin
        ? _c("settingsComponent", {
            attrs: {
              contentid: _vm.contentid,
              saving: _vm.saving,
              settings: _vm.relationSettings,
            },
            on: { saveSettings: _vm.getItems },
          })
        : _vm._e(),
      _vm.needSetup && _vm.admin && !_vm.settingsMode && !_vm.saving
        ? _c("div", { staticClass: "needSetup" }, [_vm._v(" Need setup ")])
        : _vm._e(),
      _vm.show
        ? _c(
            "div",
            [
              !_vm.settingsMode &&
              _vm.relationSettings.mode == "articles" &&
              !_vm.needSetup &&
              !_vm.saving
                ? _c("articles", {
                    attrs: {
                      items: _vm.items,
                      resultNo: _vm.relationSettings.resultNo,
                      loaded: _vm.loaded,
                      showImage: _vm.relationSettings.showImage,
                    },
                  })
                : _vm._e(),
              !_vm.settingsMode &&
              _vm.relationSettings.mode == "products" &&
              !_vm.needSetup &&
              !_vm.saving
                ? _c("products", {
                    attrs: {
                      items: _vm.items,
                      resultNo: _vm.relationSettings.resultNo,
                      productid: _vm.relationID,
                      loaded: _vm.loaded,
                      showImage: _vm.relationSettings.showImage,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _c("div", [
            !_vm.settingsMode && _vm.admin && !_vm.needSetup
              ? _c("div", { staticClass: "zeroResults" }, [
                  _vm._v(" Zero results with current settings. "),
                  _c("br"),
                  _c("br"),
                  _vm._v("This widget will be invisible for users. "),
                ])
              : _vm._e(),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }